<template>
  <div class="panel-left">
    <h2 class="mb-3">Documents</h2>
    <div class="whitecard">
      <DocumentsGraph class="mt-3"></DocumentsGraph>
      <b-table-simple class="mb-0 mt-3 small">
        <b-tbody>
          <b-tr>
            <b-td>Number of documents</b-td>
            <b-td class="text-right">{{ documentsCount }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DocumentsGraph from "../Shared/DocumentsGraph";

export default {
  name: "PanelLeft",
  components: {
    DocumentsGraph,
  },
  computed: {
    ...mapState({
      documentsCount: (state) => state.document.documentsCount,
    }),
  },
};
</script>
